import { render, staticRenderFns } from "./DashboardPanelFunnel.vue?vue&type=template&id=f05c620c&scoped=true&"
import script from "./DashboardPanelFunnel.vue?vue&type=script&lang=js&"
export * from "./DashboardPanelFunnel.vue?vue&type=script&lang=js&"
import style0 from "./DashboardPanelFunnel.vue?vue&type=style&index=0&id=f05c620c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05c620c",
  null
  
)

export default component.exports